import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIList from 'UIComponents/list/UIList';
import { EERIE } from 'HubStyleTokens/colors';
import { LearningMaterialTypes } from 'academy-shared-js/constants/ContentConstants';
import { Link } from '../AcademyLinks';
import { H5 } from 'UIComponents/elements/headings';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ResourceItem = ({
  title,
  url,
  prefix,
  onResourceClick
}) => {
  return /*#__PURE__*/_jsxs("div", {
    children: [prefix, /*#__PURE__*/_jsx(Link, {
      external: true,
      href: url,
      onClick: () => onResourceClick({
        title,
        url
      }),
      children: title
    })]
  });
};
const ResourcesList = ({
  additionalResources = [],
  className,
  onResourceClick = () => {},
  slidesUrl,
  transcriptUrl
}) => {
  if (!slidesUrl && !transcriptUrl && !additionalResources.length) {
    return /*#__PURE__*/_jsx(H5, {
      className: className,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'learningCenter.noLessonResources'
      })
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    className: className,
    children: [/*#__PURE__*/_jsx("h4", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'learningCenter.lessonResources'
      })
    }), /*#__PURE__*/_jsxs(UIList, {
      children: [slidesUrl && /*#__PURE__*/_jsx(ResourceItem, {
        onResourceClick: onResourceClick,
        prefix: /*#__PURE__*/_jsx(UIIcon, {
          className: "m-right-2",
          color: EERIE,
          name: 'documents',
          size: "xxs"
        }),
        title: I18n.text('learningCenter.resources.downloadSlides'),
        url: slidesUrl
      }), transcriptUrl && /*#__PURE__*/_jsx(ResourceItem, {
        onResourceClick: onResourceClick,
        prefix: /*#__PURE__*/_jsx(UIIcon, {
          className: "m-right-2",
          color: EERIE,
          name: 'documents',
          size: "xxs"
        }),
        title: I18n.text('learningCenter.resources.downloadTranscript'),
        url: transcriptUrl
      }), additionalResources.map(resource => {
        return /*#__PURE__*/_jsx(ResourceItem, {
          onResourceClick: onResourceClick,
          prefix: /*#__PURE__*/_jsxs(_Fragment, {
            children: [LearningMaterialTypes[resource.type] ? /*#__PURE__*/_jsx(FormattedMessage, {
              message: `learningCenter.resources.type.${resource.type}`
            }) : resource.type, ":\xA0"]
          }),
          title: resource.title,
          url: resource.targetUrl
        }, resource.title);
      })]
    })]
  });
};
export default ResourcesList;